/**
 * Набор общих хелперов
 */

/**
 * Включить полноэкранный режим
 */
export const enterFullScreen = (element: Element) => {
    if (element.requestFullscreen) {
        element.requestFullscreen();
    }
};

/**
 * Выключить полнокэранный режим
 */
export const exitFullScreen = () => {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    }
};
